import { createFileRoute, redirect } from "@tanstack/react-router";
import { getOrganizationMemberInvitation } from "api-client";

import { loaderHandler } from "src/lib/loaderHandler";
import { OrganizationMemberInvitationPage } from "src/pages/OrganizationMemberInvitationPage";

export const Route = createFileRoute("/organization-invitations/$invitationId")(
  {
    component: OrganizationMemberInvitationPage,
    ssr: true,
    async loader({ params }) {
      return loaderHandler(async () => {
        try {
          const response = await getOrganizationMemberInvitation({
            path: { invitationId: params.invitationId },
          });
          return { data: response.data.data };
        } catch {
          throw redirect({ to: "/" });
        }
      });
    },
  },
);
